<template>
    <div id="tipSelectAmount" aria-hidden="true"
         class="modal modal--rebrand fade over-all modal-with-custom-content modal-with-custom-content--dark-background"
         role="dialog" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content" v-if="user">
                <div class="modal-body text-center">
                    <div class="tip-icon-container">
                        <GemFilledComponent width="48px" height="48px"/>
                    </div>

                    <h5 class="galleryTitle">{{ translate.account.tips.sendTip }}</h5>
                    <p class="galleryDescription">
                        {{ translate.account.tips.sendTo.replace(':username', user.username) }}
                    </p>

                    <div class="tip-amount-grid">
                        <button v-for="credit in creditAmountSuggestions"
                                :key="credit"
                                class="btn btn-rebrand-primary-outline btn-rebrand-sm"
                                @click.prevent="onSuggestionClick(credit)">
                            {{ credit }}
                        </button>
                    </div>

                    <div class="tip-custom-amount">
                        <span class="galleryDescription">{{ translate.account.tips.orCustomAmount }}</span>

                        <span class="error-input-container d-block w-100" :class="{'has-error': customAmountError}">
                            <input type="text"
                                   class="form-control-v2"
                                   v-model.trim="creditsInput"
                                   @input="sanitizeInput"
                            >
                        </span>
                        <error-component v-if="customAmountError" :message="translate.account.tips.minimumAmount"/>

                        <button-with-loading-component
                            class="btn btn-rebrand-primary btn-rebrand-sm w-100"
                            :text="translate.product.confirmPurchaseTokens"
                            :disabled="!creditsInput"
                            @click.native.prevent="onCustomAmountClick()"
                        />

                        <p class="tip-disclaimer">{{ translate.account.tips.confirmSendTipDisclaimer }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GemFilledComponent from "@/components/global/icons/GemFilledComponent.vue";
import ButtonWithLoadingComponent from "@/components/global/ButtonWithLoadingComponent";

const data = () => ({
    creditsInput: '',
    customAmountError: false,
    creditAmountSuggestions: [5, 10, 25, 50, 100, 200],
})

function sanitizeInput() {
    this.creditsInput = this.creditsInput.replace(/[^0-9]/g, '');
    this.customAmountError = false;
}

function onSuggestionClick(credit) {
    this.creditsInput = '';
    this.customAmountError = false;
    $('#tipSelectAmount').modal('hide');
    this.$emit('amountSelected', credit);
}

function onCustomAmountClick() {
    const amount = Number(this.creditsInput);
    if (!amount || amount < 1) {
        this.customAmountError = true;
        return;
    }
    this.customAmountError = false;
    $('#tipSelectAmount').modal('hide');
    this.$emit('amountSelected', amount);
}

function initModal() {
    this.creditsInput = '';
    this.customAmountError = false;
    setTimeout(() => {
        $(() => {
            const element = $('#tipSelectAmount');
            if (element && typeof element.modal === 'function') {
                element.modal('show');
            }
        });
    });
}

export default {
    data,
    props: {
        user: {
            type: Object,
            default: null,
        },
    },
    computed: {
        ...mapState(['translate']),
    },
    methods: {
        initModal,
        sanitizeInput,
        onSuggestionClick,
        onCustomAmountClick,
    },
    components: {
        GemFilledComponent,
        ButtonWithLoadingComponent,
    },
    beforeDestroy() {
        window.clearModalFade();
    },
};
</script>
